export const contactRequestUrlFormatter = (token: string) => {
  return `${window.location.origin}/submit-contact?t=${token}`
}
